const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_pages/$lang/pages/cd-price-alerts/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_pages/$lang/pages/cd-price-alerts/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { buildLandingPageHead } from "@/features/landing/build-landing-page-head";
import { PRICE_ALERT_METADATA } from "@/routes/_pages/$lang/pages/-price-alert-metadata";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_pages/$lang/pages/cd-price-alerts/")({
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match
  }) => {
    const {
      locale
    } = getRootLoaderData(match);
    return await buildLandingPageHead({
      locale,
      metadata: PRICE_ALERT_METADATA.cd[locale],
      slug: "cd-price-alerts"
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});